// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE cf-component-icon/src/svgtoreact.sh TO MODIFY

import React from 'react';
import PropTypes from 'prop-types';

var Edgeworker = function Edgeworker(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return React.createElement(
    'svg',
    {
      className: className,
      'aria-label': label,
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16'
    },
    React.createElement('path', { d: 'M4.92 9.18v1.16a1.18 1.18 0 0 0 .41 1 2.32 2.32 0 0 0 1.35.32v-.75a1.09 1.09 0 0 1-.68-.16.62.62 0 0 1-.21-.5V9q0-.82-.93-1 .93-.16.93-1V5.83a.61.61 0 0 1 .21-.5 1.16 1.16 0 0 1 .67-.19V4.4a2.38 2.38 0 0 0-1.33.3 1 1 0 0 0-.44.93V6.9a.64.64 0 0 1-.27.56 1.44 1.44 0 0 1-.82.19v.78q1.11 0 1.11.75zM11.14 10.43V9.18a.65.65 0 0 1 .26-.58 1.39 1.39 0 0 1 .76-.17v-.78a1.4 1.4 0 0 1-.77-.17.64.64 0 0 1-.26-.58V5.73a1.22 1.22 0 0 0-.4-1 2.14 2.14 0 0 0-1.3-.31v.74a1 1 0 0 1 .63.19.65.65 0 0 1 .19.5V7q0 .81.93 1a1.12 1.12 0 0 0-.72.35 1.19 1.19 0 0 0-.22.76v1.07a.6.6 0 0 1-.22.53 1 1 0 0 1-.6.16v.75a2.26 2.26 0 0 0 1.3-.31 1.08 1.08 0 0 0 .42-.88zM4.45 2.19a.6.6 0 0 0 .37-.14.61.61 0 1 0-.74 0 .6.6 0 0 0 .37.14zM6.28 2.19a.6.6 0 0 0 .37-.14.61.61 0 1 0-.74 0 .6.6 0 0 0 .37.14zM8.1 2.19a.6.6 0 0 0 .37-.14.61.61 0 1 0-.74 0 .6.6 0 0 0 .37.14z' }),
    React.createElement('path', { d: 'M13.93 1H9.44v1.11h4.49V14H2.07V2.11h1V1h-1A1.07 1.07 0 0 0 1 2.11V14a1.07 1.07 0 0 0 1.07 1h11.86A1.07 1.07 0 0 0 15 14V2.11A1.07 1.07 0 0 0 13.93 1z' })
  );
};

Edgeworker.propTypes = {
  className: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default Edgeworker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Edgeworker.js
// module id = 1025
// module chunks = 1